import { render, staticRenderFns } from "./transactionHistoryNew.vue?vue&type=template&id=67d93366&"
import script from "./transactionHistoryNew.vue?vue&type=script&lang=js&"
export * from "./transactionHistoryNew.vue?vue&type=script&lang=js&"
import style0 from "./transactionHistoryNew.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports